module.exports = __webpack_public_path__ + "img/google-news-fr.273419ed.png";